import React from "react";
import _ from 'i18n';

const Piechart = ({ total, count, label, pieColor, multi,style, color, count2, countRappel }) => {


    
    const radius = 60;
    const rate = (total>0)?count/total*100:0;
    const rate2 = (total>0)?count2/total*100:0;

    let perimeter = 2 * Math.PI * radius;
    let strokeDashoffset = ((100 - rate) / 100) * perimeter;
    let strokeDashoffset2 = ((rate / 100) * perimeter) +20;
    let strokeDashoffset3 = ((100 - rate2) / 100) * perimeter;
    const circleColor = (color) || '#18A0FB';
    const showMulti = multi && total >0;
    return (
        <div className="piechart">
          <div className="piechart-wrapper">
            <div className="piechart-container">
              <div className="piechart__percentage" style = {{color: countRappel ? '#FE3745' : circleColor}}>
                <div className="piechart__percentage-number">{multi?total:(countRappel ? countRappel : count)}</div>
                <div className="piechart__percentage-label" >{label}</div>
              </div>
              <svg width="140" height="140" className={showMulti && 'multi'} >
                <circle className={count2 && total >0 ? "piechart-circle__empty2" : "piechart-circle__empty"} r={radius} cy="70" cx="70" stroke={showMulti?"#18A0FB":pieColor} fill="#ffffff"></circle>
                <circle style={{ strokeDashoffset, strokeDasharray: perimeter }} className={count2 ? "piechart-circle__fill2" : "piechart-circle__fill"} r={radius} cy="70" cx="70" stroke={multi?"#E0F8EF":circleColor} fill="none"></circle>
                {
                  showMulti && <circle style={{ strokeDashoffset: -strokeDashoffset2, strokeDasharray: perimeter }} className="piechart-circle__fill piechart-circle__second " r={radius} cy="70" cx="70" stroke={"#FFE0E2"} fill="none"></circle>
                }

                {
                  count2 && <circle style={{ strokeDashoffset: -strokeDashoffset3, strokeDasharray: perimeter }} className="piechart-circle__fill2" r={radius} cy="70" cx="70" stroke={"#FE3745"} fill="none"></circle>
                }

              </svg>
            </div>
          </div>
        </div>
    );
}

export default Piechart;


// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/PieChart.js